import { CustomerContext, OpenBankingConfiguration } from "Shared/util/types";
import {
    PayoutInformationBankConsent,
    FinaComputedConsentStatus,
} from "Shared/util/types/api";

/**
 * Categorises consents based on the specified consent status.
 * @returns Array of consents.
 */
export const categoriseConsents = (
    bankConsents: PayoutInformationBankConsent[],
    status: FinaComputedConsentStatus,
) =>
    (bankConsents || []).filter((item) =>
        item.accounts.some((x) => x.consentStatus === status),
    );

/**
 * Checks if any consent is due very soon.
 * @returns Boolean.
 */
export const checkForConsentDueVerySoon = (
    bankConsent: PayoutInformationBankConsent,
    openBankingConfiguration: OpenBankingConfiguration,
) =>
    bankConsent.accounts.some((account) => {
        if (
            account.consentExpiresAt &&
            new Date(account.consentExpiresAt).getTime() <
                getConsentExpiresVerySoonDate(
                    openBankingConfiguration.consentExpiresVerySoonDays,
                ).getTime()
        ) {
            return true;
        }
        return false;
    });

const getConsentExpiresVerySoonDate = (numberOfDays: number): Date => {
    const currentDate = new Date();
    const expiresDate = new Date(currentDate);
    expiresDate.setDate(currentDate.getDate() + numberOfDays);
    return expiresDate;
};

/**
 * Finds the shortest consent expiry date.
 * @returns Number of days before expiry.
 */
export const findShortestConsentExpiry = (
    consent: PayoutInformationBankConsent,
) => {
    const dateAsNumber = Math.min(
        ...consent.accounts.map((account) =>
            account.consentExpiresAt
                ? new Date(account.consentExpiresAt).getTime()
                : Infinity,
        ),
    );
    const date = new Date(dateAsNumber);

    const daysBeforeExpiry = Math.floor(
        (date.getTime() - new Date().getTime()) / (1000 * 60 * 60 * 24),
    );

    return daysBeforeExpiry;
};

export const customerIsValidForBanners = (
    customerData?: CustomerContext | null,
) => !!(!customerData?.bankruptcy && !customerData?.isInactive);
